<template>
  <v-card flat>
    <v-divider class="my-4" />
    <v-row no-gutters>
      <!-- Sidebar / Tabs -->
      <v-col cols="auto" class="sidebar-col">
        <v-tabs
          v-model="tab"
          vertical
          background-color="transparent"
          grow
        >
          <v-tab href="#pago_tipos"
            @click="actualizarItems('pago_tipos')"
          >
            Tipos de Pagos
          </v-tab>

          <v-tab href="#pago_formas"
            @click="actualizarItems('pago_formas')"
          >
            Formas de Pago
          </v-tab>

          <v-tab href="#reglas_fiscales"
            @click="actualizarItems('reglas_fiscales')"
          >
            Reglas Fiscales
          </v-tab>

          <!--
          <v-tab href="#gasto_rega_conceptos"
            @click="actualizarItems('gasto_rega_conceptos')"
          >
            Concepto de <br> gasto REGA's
          </v-tab>

          <v-tab href="#puesto_pago_tarjeta_regas"
            @click="actualizarItems('puesto_pago_tarjeta_regas')"
          >
            Puestos Pagos <br> con Tarjeta
          </v-tab>

          <v-tab href="#cuentas_bancarias_institucionales"
            @click="actualizarItems('cuentas_bancarias_institucionales')"
          >
            Cuentas Bancarias <br> Institucionales
          </v-tab>

          -->
        </v-tabs>
      </v-col>

      <!-- Contenido -->
      <v-col>
        <v-tabs-items v-model="tab" touchless>
          <v-tab-item value="pago_tipos">
            <v-card flat>
              <pago-tipos
                ref="pago_tipos"
              ></pago-tipos>
            </v-card>
          </v-tab-item>

          <v-tab-item value="pago_formas">
            <v-card flat>
              <pago-formas
                ref="pago_formas"
              ></pago-formas>
            </v-card>
          </v-tab-item>

          <v-tab-item value="reglas_fiscales">
            <v-card flat>
              <fiscal-reglas
                ref="reglas_fiscales"
              ></fiscal-reglas>
            </v-card>
          </v-tab-item>

          <v-tab-item value="gasto_rega_conceptos">
            <v-card flat>
              <gasto-rega-conceptos
                ref="gasto_rega_conceptos"
              ></gasto-rega-conceptos>
            </v-card>
          </v-tab-item>

          <v-tab-item value="puesto_pago_tarjeta_regas">
            <v-card flat>
              <puesto-pago-tarjeta-regas
                ref="puesto_pago_tarjeta_regas"
              ></puesto-pago-tarjeta-regas>
            </v-card>
          </v-tab-item>

          <v-tab-item value="cuentas_bancarias_institucionales">
            <v-card flat>
              <cuentas-bancarias-institucionales
                ref="cuentas_bancarias_institucionales"
              ></cuentas-bancarias-institucionales>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>


import { mapState } from 'vuex'
import PagoFormas from './Catalogos/PagoFormas.vue'
import GastoRegaConceptos from './Catalogos/GastoRegaConceptos.vue'
import PuestoPagoTarjetaRegas from './Catalogos/PuestoPagoTarjetaRegas.vue'
import CuentasBancariasInstitucionales from './Catalogos/CuentasBancariasInstitucionales.vue'
import PagoTipos from './Catalogos/GastoTipos.vue'
import FiscalReglas from './Catalogos/FiscalReglas.vue'

export default {
  components: {
    PagoFormas,
    GastoRegaConceptos,
    PuestoPagoTarjetaRegas,
    CuentasBancariasInstitucionales,
    PagoTipos,
    FiscalReglas
  },
  data: () => ({
    tab: null,
  }),
  computed: {
    ...mapState(['ids_vistas', 'vinculado']),
  },
  mounted () {
    this.actualizarItems(this.tab)
  },
  methods: {
    mostrarVista (id_vista) {
      if (!this.ids_vistas || this.ids_vistas.length === 0) return false
      return this.ids_vistas.indexOf(id_vista) >= 0
    },
    getItems () {
      this.actualizarItems(this.tab)
    },
    actualizarItems (refName) {
      const r = this.$refs[refName]
      if (r && typeof r.getItems === 'function') r.getItems()
    },
  }
}
</script>

<style scoped>
/* Asegura que el v-tabs use todo el alto disponible en la columna */
.sidebar-col,
.sidebar-col .v-tabs {
  height: 100%;
}
</style>